/**
 * Created By Henal Khianra
 * Created at 27/02/2020
 * https://marvelapp.com/4g4b5dg/screen/58840158
 */

import React from 'react';
import loadable from '@loadable/component';
import values from 'ramda/src/values';
import { Document, Font, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import Icon from '@components/@core/Icon';

const Header = loadable(() => import('@components/PdfHeader'), { ssr: false });

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '10px',
        paddingTop: '3px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
    },
    mainHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '3px',
        paddingTop: '10px',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: '8px 10px 0px 10px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
        minHeight: 35,
        maxHeight: 100,
    },
    pageNumbers: {
        position: 'absolute',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        margin: '10px',
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    listHeaderTitle: { fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' },
    listItemFont: { fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' },
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

export const TrainingTrackPdf = (tracks) => {
    const pageTitle = 'Report - Training Track';
    let pageIndex = 1;
    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <Header header={pageTitle} style={{ paddingTop: '20px', paddingBottom: '20px' }} fixed />

                {tracks?.length === 0 ? (
                    <View wrap style={{ display: 'flex', paddingBottom: 20 }}>
                        <View style={styles.listHeader} fixed>
                            <View style={{ flex: 4, textAlign: 'center' }}>
                                <Text style={styles.listHeaderTitle}>No Tracks Assigned</Text>
                            </View>
                        </View>
                    </View>
                ) : (
                    <View wrap style={{ display: 'flex' }}>
                        <View style={styles.mainHeader} fixed>
                            <View style={{ flex: 4 }}>
                                <Text style={styles.title}>Learning Track Report</Text>
                            </View>
                        </View>
                        <View style={styles.listHeader} fixed>
                            <View style={{ flex: 3.5 }}>
                                <Text style={styles.listHeaderTitle}>Tracks</Text>
                            </View>
                            <View style={{ flex: 1.5 }}>
                                <Text style={styles.listHeaderTitle}>Assigned by</Text>
                            </View>
                            <View style={{ flex: 1, textAlign: 'right' }}>
                                <Text style={styles.listHeaderTitle}>Start Date</Text>
                            </View>
                            <View style={{ flex: 1, textAlign: 'right' }}>
                                <Text style={styles.listHeaderTitle}>Due Date</Text>
                            </View>
                            <View style={{ flex: 0.8, textAlign: 'right', paddingRight: 5 }}>
                                <Text style={styles.listHeaderTitle}>Assigned</Text>
                            </View>
                        </View>
                        {tracks.map(function (item, index) {
                            const track = values(item.users)[0]?.track;
                            const assignedBy = `${track?.assigned_by?.profile?.first_name || ''} ${track?.assigned_by?.profile?.last_name || ''}`;
                            const ds = moment(track?.created_at).format('MMM DD');
                            const de = moment(track?.due_date).format('MMM DD');
                            let pageBreak = false;
                            if (pageIndex === 13) {
                                pageBreak = true;
                                pageIndex = 1;
                            }
                            pageIndex++;
                            return (
                                <View style={styles.listItem} key={`crd${index}`} wrap break={pageBreak}>
                                    <View style={{ flex: 3.5 }}>
                                        <Text style={styles.listItemFont}>{item?.title}</Text>
                                    </View>
                                    <View style={{ flex: 1.5 }}>
                                        <Text style={styles.listItemFont}>{assignedBy}</Text>
                                    </View>
                                    <View style={{ flex: 1, textAlign: 'right' }}>
                                        <Text style={styles.listItemFont}>{ds}</Text>
                                    </View>
                                    <View style={{ flex: 1, textAlign: 'right' }}>
                                        <Text style={styles.listItemFont}>{de}</Text>
                                    </View>
                                    <View style={{ flex: 0.8, textAlign: 'right', paddingRight: '5px' }}>
                                        <Text style={styles.listItemFont}>{values(item.users).length}</Text>
                                    </View>
                                </View>
                            );
                        })}
                    </View>
                )}

                <Text fixed style={styles.pageNumbers} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

const PdfIcon = ({ state, props, name }) => {
    const handlePdf = () => {};

    return <Icon name="fas fa-print" color="#343f4b" size={16} data-cy="hcm-report-trainingSchedulePrintBtn" onClick={handlePdf} />;
};

export default PdfIcon;
